// Generic
import submitPlatformPost from '@/graphql/mutations/submissions/submitPlatformPost.gql'
// Reddit
import bulkDeleteRedditPostSubmissions from '@/graphql/mutations/posts/bulkDeleteRedditPostSubmissions.gql'
import deleteRedditPostSubmission from '@/graphql/mutations/posts/deleteRedditPostSubmission.gql'
import duplicateRedditPost from '@/graphql/mutations/posts/duplicateRedditPost.gql'
import submitRedditSubmission from '@/graphql/mutations/posts/submitRedditSubmission.gql'
import updateRedditPostSubmissionPostAt from '@/graphql/mutations/posts/updateRedditPostSubmissionPostAt.gql'
import allRedditSubmissions from '@/graphql/queries/posts/allRedditSubmissions.gql'
// Twitter
import deleteTwitterPost from '@/graphql/mutations/twitter/deleteTwitterPost.gql'
import bulkDeleteTwitterPosts from '@/graphql/mutations/twitter/bulkDeleteTwitterPosts.gql'
import rescheduleTwitterPost from '@/graphql/mutations/twitter/rescheduleTwitterPost.gql'
import duplicateTwitterPost from '@/graphql/mutations/twitter/duplicateTwitterPost.gql'
import deleteTwitterSubmission from '@/graphql/mutations/twitter/deleteTwitterSubmission.gql'
import cancelAutoRetweet from '@/graphql/mutations/twitter/cancelAutoRetweet.gql'
import cancelAutoRemove from '@/graphql/mutations/twitter/cancelAutoRemove.gql'
import allTwitterSubmissions from '@/graphql/queries/twitter/allTwitterSubmissions.gql'
// Threads
import deleteThreadsPost from '@/graphql/mutations/threads/deleteThreadsPost.gql'
import bulkDeleteThreadsPosts from '@/graphql/mutations/threads/bulkDeleteThreadsPosts.gql'
import rescheduleThreadsPost from '@/graphql/mutations/threads/rescheduleThreadsPost.gql'
import duplicateThreadsPost from '@/graphql/mutations/threads/duplicateThreadsPost.gql'
import deleteThreadsSubmission from '@/graphql/mutations/threads/deleteThreadsSubmission.gql'
import cancelThreadsAutoRepost from '@/graphql/mutations/threads/cancelThreadsAutoRepost.gql'
import cancelThreadsAutoRemove from '@/graphql/mutations/threads/cancelThreadsAutoRemove.gql'
// Instagram
import deleteInstagramPost from '@/graphql/mutations/instagram/deleteInstagramPost.gql'
import rescheduleInstagramSubmission from '@/graphql/mutations/instagram/rescheduleInstagramSubmission.gql'
import duplicateInstagramPost from '@/graphql/mutations/instagram/duplicateInstagramPost.gql'
import bulkDeleteInstagramPosts from '@/graphql/mutations/instagram/bulkDeleteInstagramPosts.gql'
import allInstagramSubmissions from '@/graphql/queries/instagram/allInstagramSubmissions.gql'
// TikTok
import duplicateTikTokPost from '@/graphql/mutations/tiktok/duplicateTikTokPost.gql'
import deleteTikTokPost from '@/graphql/mutations/tiktok/deleteTikTokPost.gql'
import bulkDeleteTikTokPosts from '@/graphql/mutations/tiktok/bulkDeleteTikTokPosts.gql'
import rescheduleTikTokSubmission from '@/graphql/mutations/tiktok/rescheduleTikTokSubmission.gql'
import allTikTokSubmissions from '@/graphql/queries/tiktok/allTikTokSubmissions.gql'
// YouTube
import duplicateYouTubePost from '@/graphql/mutations/youtube/duplicateYouTubePost.gql'
import deleteYouTubePost from '@/graphql/mutations/youtube/deleteYouTubePost.gql'
import bulkDeleteYouTubePosts from '@/graphql/mutations/youtube/bulkDeleteYouTubePosts.gql'
import rescheduleYouTubeSubmission from '@/graphql/mutations/youtube/rescheduleYouTubeSubmission.gql'
import allYouTubeSubmissions from '@/graphql/queries/youtube/allYouTubeSubmissions.gql'
import removeSubmissionFromYouTube from '@/graphql/mutations/youtube/removeSubmissionFromYouTube.gql'
// Bluesky
import deleteBlueskyPost from '@/graphql/mutations/bluesky/deleteBlueskyPost.gql'
import bulkDeleteBlueskyPosts from '@/graphql/mutations/bluesky/bulkDeleteBlueskyPosts.gql'
import rescheduleBlueskyPost from '@/graphql/mutations/bluesky/rescheduleBlueskyPost.gql'
import duplicateBlueskyPost from '@/graphql/mutations/bluesky/duplicateBlueskyPost.gql'
import removeSubmissionFromBluesky from '@/graphql/mutations/bluesky/removeSubmissionFromBluesky.gql'
import cancelBlueskyAutoRepost from '@/graphql/mutations/bluesky/cancelBlueskyAutoRepost.gql'
import cancelBlueskyAutoRemove from '@/graphql/mutations/bluesky/cancelBlueskyAutoRemove.gql'
import allBlueskySubmissions from '@/graphql/queries/bluesky/allBlueskySubmissions.gql'
// Tumblr
import deleteTumblrPost from '@/graphql/mutations/tumblr/deleteTumblrPost.gql'
import bulkDeleteTumblrPosts from '@/graphql/mutations/tumblr/bulkDeleteTumblrPosts.gql'
import rescheduleTumblrSubmission from '@/graphql/mutations/tumblr/rescheduleTumblrSubmission.gql'
import duplicateTumblrPost from '@/graphql/mutations/tumblr/duplicateTumblrPost.gql'
import allTumblrSubmissions from '@/graphql/queries/tumblr/allTumblrSubmissions.gql'
// Mastodon
import duplicateMastodonPost from '@/graphql/mutations/mastodon/duplicateMastodonPost.gql'
import deleteMastodonPost from '@/graphql/mutations/mastodon/deleteMastodonPost.gql'
import bulkDeleteMastodonPosts from '@/graphql/mutations/mastodon/bulkDeleteMastodonPosts.gql'
import rescheduleMastodonPost from '@/graphql/mutations/mastodon/rescheduleMastodonPost.gql'
import allMastodonSubmissions from '@/graphql/queries/mastodon/allMastodonSubmissions.gql'
import removeSubmissionFromMastodon from '@/graphql/mutations/mastodon/removeSubmissionFromMastodon.gql'
import cancelMastodonAutoRemove from '@/graphql/mutations/mastodon/cancelMastodonAutoRemove.gql'

export const PLATFORM_CODE_REDDIT = 'reddit'
export const PLATFORM_CODE_TWITTER = 'twitter'
export const PLATFORM_CODE_THREADS = 'threads'
export const PLATFORM_CODE_INSTAGRAM = 'instagram'
export const PLATFORM_CODE_TIKTOK = 'tiktok'
export const PLATFORM_CODE_YOUTUBE = 'youtube'
export const PLATFORM_CODE_BLUESKY = 'bluesky'
export const PLATFORM_CODE_TUMBLR = 'tumblr'
export const PLATFORM_CODE_MASTODON = 'mastodon'

export const PLATFORM_NAME_REDDIT = 'Reddit'
export const PLATFORM_NAME_TWITTER = 'X / Twitter'
export const PLATFORM_NAME_THREADS = 'Threads'
export const PLATFORM_NAME_INSTAGRAM = 'Instagram'
export const PLATFORM_NAME_TIKTOK = 'TikTok'
export const PLATFORM_NAME_YOUTUBE = 'YouTube'
export const PLATFORM_NAME_BLUESKY = 'Bluesky'
export const PLATFORM_NAME_TUMBLR = 'Tumblr'
export const PLATFORM_NAME_MASTODON = 'Mastodon'

export const platforms = [
  {
    code: PLATFORM_CODE_REDDIT,
    name: PLATFORM_NAME_REDDIT,
    icon: 'reddit',
    color: '#ff4500',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitRedditSubmission,
      submitPostVariables: (submission) => {
        return {
          submissionId: submission.id,
          platform: submission.platform.toLowerCase()
        }
      },
      deletePost: deleteRedditPostSubmission,
      deletePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      bulkDeletePosts: bulkDeleteRedditPostSubmissions,
      bulkDeletePostsVariables: (submissions) => {
        return { submissionIds: submissions.map((s) => s.id) }
      },
      reschedulePost: updateRedditPostSubmissionPostAt,
      reschedulePostVariables: (submission) => {
        return { id: submission.id }
      },
      duplicatePost: duplicateRedditPost
    },
    queries: {
      allSubmissions: allRedditSubmissions
    }
  },
  {
    code: PLATFORM_CODE_TWITTER,
    name: PLATFORM_NAME_TWITTER,
    icon: 'square-x-twitter',
    color: '#000000',
    accountNoun: 'Account',
    postNoun: 'Post',
    repostNoun: 'Retweet',
    mutations: {
      // Dashboard
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteTwitterPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteTwitterPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleTwitterPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateTwitterPost,
      // History
      removeSubmissionFromPlatformMutation: deleteTwitterSubmission,
      cancelAutoRepostMutation: cancelAutoRetweet,
      cancelAutoRemoveMutation: cancelAutoRemove
    },
    queries: {
      allSubmissions: allTwitterSubmissions
    }
  },
  {
    code: PLATFORM_CODE_THREADS,
    name: PLATFORM_NAME_THREADS,
    icon: 'threads',
    color: '#000000',
    accountNoun: 'Account',
    postNoun: 'Thread',
    mutations: {
      // Dashboard
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteThreadsPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteThreadsPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleThreadsPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateThreadsPost,
      // History
      removeSubmissionFromPlatformMutation: deleteThreadsSubmission,
      cancelAutoRepostMutation: cancelThreadsAutoRepost,
      cancelAutoRemoveMutation: cancelThreadsAutoRemove
    },
    queries: {
      allSubmissions: null
    }
  },
  {
    code: PLATFORM_CODE_INSTAGRAM,
    name: PLATFORM_NAME_INSTAGRAM,
    icon: 'instagram',
    color: '#e1306c',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteInstagramPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteInstagramPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleInstagramSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateInstagramPost
    },
    queries: {
      allSubmissions: allInstagramSubmissions
    }
  },
  {
    code: PLATFORM_CODE_TIKTOK,
    name: PLATFORM_NAME_TIKTOK,
    icon: 'tiktok',
    color: '#000000',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteTikTokPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteTikTokPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleTikTokSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateTikTokPost
    },
    queries: {
      allSubmissions: allTikTokSubmissions
    }
  },
  {
    code: PLATFORM_CODE_YOUTUBE,
    name: PLATFORM_NAME_YOUTUBE,
    icon: 'youtube',
    color: '#FF0000',
    accountNoun: 'Channel',
    postNoun: 'Short',
    mutations: {
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteYouTubePost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteYouTubePosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleYouTubeSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateYouTubePost,
      removeSubmissionFromPlatformMutation: removeSubmissionFromYouTube
    },
    queries: {
      allSubmissions: allYouTubeSubmissions
    }
  },
  {
    code: PLATFORM_CODE_BLUESKY,
    name: PLATFORM_NAME_BLUESKY,
    icon: 'bluesky',
    color: '#0085FF',
    accountNoun: 'Account',
    postNoun: 'Post',
    repostNoun: 'Repost',
    mutations: {
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteBlueskyPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteBlueskyPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleBlueskyPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateBlueskyPost,
      removeSubmissionFromPlatformMutation: removeSubmissionFromBluesky,
      cancelAutoRepostMutation: cancelBlueskyAutoRepost,
      cancelAutoRemoveMutation: cancelBlueskyAutoRemove
    },
    queries: {
      allSubmissions: allBlueskySubmissions
    }
  },
  {
    code: PLATFORM_CODE_TUMBLR,
    name: PLATFORM_NAME_TUMBLR,
    icon: 'tumblr',
    color: '#001935',
    accountNoun: 'Blog',
    postNoun: 'Post',
    mutations: {
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteTumblrPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteTumblrPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleTumblrSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateTumblrPost
    },
    queries: {
      allSubmissions: allTumblrSubmissions
    }
  },
  {
    code: PLATFORM_CODE_MASTODON,
    name: PLATFORM_NAME_MASTODON,
    icon: 'mastodon',
    color: '#6364ff',
    postNoun: 'Post',
    repostNoun: 'Boost',
    accountNoun: 'Account',
    mutations: {
      submitPost: submitPlatformPost,
      submitPostVariables: (submission) => {
        return {
          postId: submission.postId,
          platform: submission.platform.toUpperCase()
        }
      },
      deletePost: deleteMastodonPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteMastodonPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleMastodonPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateMastodonPost,
      removeSubmissionFromPlatformMutation: removeSubmissionFromMastodon,
      cancelAutoRemoveMutation: cancelMastodonAutoRemove
    },
    queries: {
      allSubmissions: allMastodonSubmissions
    }
  }
]

/**
 * Platforms that are not Reddit. These all follow the same new pattern.
 */
export const newPlatforms = platforms.filter(
  (p) => p.code !== PLATFORM_CODE_REDDIT
)

export const platformCodes = platforms.map((platform) => platform.code)

export const newPlatformCodes = newPlatforms.map((platform) => platform.code)

export const platformNames = platforms.map((platform) => platform.name)

export function getPlatform(code) {
  return platforms.find(
    (platform) => platform.code === code.toLowerCase().trim()
  )
}

export function getPlatformName(code) {
  return getPlatform(code).name
}

export function getPlatformIcon(code) {
  return getPlatform(code).icon
}
